import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidationErrors, FormArray } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { TranslatorService } from 'src/app/services/translate.service';



@Component({
  selector: 'edit-operators-dialog',
  templateUrl: './edit-operators-dialog.html',
  styleUrls: ['./edit-operators-dialog.scss'],
})
export class EditOperatorsDialogComponent implements OnInit {
  faSync = faSync;
  filteredResources: any[];
  resourcesData: any[];
  availableResources: any[][] = [];; // questa proprietà viene impiegata per tenere traccia delle risorse disponibili
  availableResourcesFiltered: any[][] = [];
  filteredResourcesToAdd: any[][] = [];  // per filtrare resourcesToAdd
  //aggiunti per modifica ricerca (codice sottostante)
  orderSearchControl = new FormControl();
  resourceToAddSearchControl = new FormControl();
  resourceToReplaceSearchControl = new FormControl();
  filteredOrders: any[];

  resourcesToReplaceSearchControls: FormControl[] = [];
  resourcesToAddSearchControls: FormControl[] = [];

  showRoleMismatchWarning: boolean = false;

  showSkipHintOnce = false;
  private readonly DEBUG = true;
  private L(...args: any[]) { }

  // anteprima assenze per ogni gruppo di risorse
  absencePreview: Array<{ checked: boolean; items: AbsencePreviewItem[] }> = [];

  form: FormGroup = this.fb.group({
    orderId: [null, [Validators.required]],
    resources: this.fb.array([]),
    dates: this.fb.array([], [this.dateBlocksValidator.bind(this)]),
  });



  get dates(): FormArray {
    return this.form.get('dates') as FormArray;
  }


  constructor(
    public dialogRef: MatDialogRef<EditOperatorsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public translate: TranslatorService
  ) { }


  minStartDate: Date | null = null;
  maxStartDate: Date | null = null;
  minEndDate: Date | null = null;
  maxEndDate: Date | null = null;
  todayDate: Date = new Date;
  isValid: boolean;



  private singleBlockValidator(group: AbstractControl): ValidationErrors | null {
    const start = group.get('startDate')?.value;
    const end = group.get('endDate')?.value;
    if (!start || !end) return null;

    const s = moment(start).utc(true).startOf('day');
    const e = moment(end).utc(true).endOf('day');

    if (!s.isSameOrBefore(e)) {
      group.get('startDate')?.setErrors({ notEquivalent: true });
      group.get('endDate')?.setErrors({ notEquivalent: true });
      return { invalidDateRange: true };
    } else {
      if (group.get('startDate')?.hasError('notEquivalent')) group.get('startDate')?.setErrors(null);
      if (group.get('endDate')?.hasError('notEquivalent')) group.get('endDate')?.setErrors(null);
    }

    // rispetta i limiti delle commesse selezionate
    const idsRaw = this.form.get('orderId')?.value;
    const ids: number[] = Array.isArray(idsRaw) ? idsRaw : (idsRaw != null ? [idsRaw] : []);
    const bounds = this.computeDateBoundsForOrders(ids);
    if (bounds) {
      const minStart = moment(bounds.minStart).utc(true).startOf('day');
      const maxEnd = moment(bounds.maxEnd).utc(true).endOf('day');
      let out = false;
      if (s.isBefore(minStart)) { group.get('startDate')?.setErrors({ outOfOrderRange: true }); out = true; }
      if (e.isAfter(maxEnd)) { group.get('endDate')?.setErrors({ outOfOrderRange: true }); out = true; }
      if (out) return { outOfOrderRange: true };
      if (group.get('startDate')?.hasError('outOfOrderRange')) group.get('startDate')?.setErrors(null);
      if (group.get('endDate')?.hasError('outOfOrderRange')) group.get('endDate')?.setErrors(null);
    }

    return null;
  }

  private dateBlocksValidator(ctrl: AbstractControl): ValidationErrors | null {
    const arr = ctrl as FormArray;
    const blocks = (arr.controls || [])
      .map(g => {
        const s = g.get('startDate')?.value;
        const e = g.get('endDate')?.value;
        if (!s || !e) return null;
        return { start: new Date(s), end: new Date(e) };
      })
      .filter(Boolean) as Array<{ start: Date; end: Date }>;

    if (!blocks.length) return { empty: true };

    blocks.sort((a, b) => a.start.getTime() - b.start.getTime());
    for (let i = 1; i < blocks.length; i++) {
      const prev = blocks[i - 1], cur = blocks[i];
      if (prev.end.getTime() >= cur.start.getTime()) {
        return { overlappingBlocks: true };
      }
    }
    return null;
  }
  private createDateBlockGroup(): FormGroup {
    const g = this.fb.group(
      {
        startDate: [null, [Validators.required]],
        endDate: [null, [Validators.required]],
      },
      { validators: this.singleBlockValidator.bind(this) }
    );
    g.valueChanges.subscribe(() => {
      this.form.updateValueAndValidity({ emitEvent: false });
      this.resources.controls.forEach((_, idx) => this.refreshAbsencePreviewForGroup(idx));
    });
    return g;
  }

  addDateBlock(): void {
    this.dates.push(this.createDateBlockGroup());
    this.form.updateValueAndValidity();
  }

  removeDateBlock(index: number): void {
    this.dates.removeAt(index);
    this.form.updateValueAndValidity();
  }



  private differentOperatorsValidator(group: AbstractControl): ValidationErrors | null {
    const toReplace = group.get('resourcesToReplace')?.value;
    const toAdd = group.get('resourcesToAdd')?.value;

    if (toReplace != null && toAdd != null && Number(toReplace) === Number(toAdd)) {
      // segna l'errore sul campo "da aggiungere" (più chiaro per l'utente)
      const ctrl = group.get('resourcesToAdd');
      const prev = ctrl?.errors || {};
      ctrl?.setErrors({ ...prev, sameOperator: true });
      return { sameOperator: true };
    }

    // pulizia soft: rimuovi SOLO il nostro errore se presente
    const ctrl = group.get('resourcesToAdd');
    if (ctrl?.hasError('sameOperator')) {
      const { sameOperator, ...others } = ctrl.errors || {};
      ctrl.setErrors(Object.keys(others).length ? others : null);
    }
    return null;
  }



  private getOrderDates(order: any): { start: moment.Moment, end: moment.Moment } | null {
    // ora order.startDate / order.endDate sono Date
    const s = order?.startDate ? moment(order.startDate).utc(true).startOf('day') : null;
    const e = order?.endDate ? moment(order.endDate).utc(true).endOf('day') : null;
    if (!s || !e) return null;
    return { start: s, end: e };
  }


  private computeDateBoundsForOrders(selectedOrderIds: number[]): { minStart: Date, maxEnd: Date } | null {
    const selected = this.data.orders.filter(o => selectedOrderIds.includes(o.id));
    const ranges = selected
      .map(o => this.getOrderDates(o))
      .filter((r): r is { start: moment.Moment, end: moment.Moment } => !!r);

    if (ranges.length === 0) return null;

    // Intersezione: start = max di tutti gli start; end = min di tutte le end
    const maxStart = moment.max(ranges.map(r => r.start));
    const minEnd = moment.min(ranges.map(r => r.end));

    if (maxStart.isAfter(minEnd)) {
      // Nessuna intersezione valida
      return null;
    }

    return { minStart: maxStart.toDate(), maxEnd: minEnd.toDate() };
  }

  ngOnInit() {
    console.log('this.data', this.data);
    if (this.dates.length === 0) this.addDateBlock();


    this.filteredOrders = this.data.orders;


    this.form.get('orderId')?.valueChanges.subscribe((selectedOrderIds: number[] | number) => {
      const ids = Array.isArray(selectedOrderIds) ? selectedOrderIds : (selectedOrderIds != null ? [selectedOrderIds] : []);

      const filteredResources = this.filterResourcesToReplaceByOrderIds(ids);
      this.resources.controls.forEach((group, index) => {
        this.availableResources[index] = filteredResources;
        this.filteredResourcesToAdd[index] = this.data.resources;
        this.availableResourcesFiltered[index] = filteredResources;
      });

      const bounds = this.computeDateBoundsForOrders(ids);
      if (!bounds) {
        this.minStartDate = this.maxStartDate = this.minEndDate = this.maxEndDate = null;
        this.toastr.warning(this.translate.instant('PLANNER.NoCommonPeriod'), this.translate.instant('TOASTR.WARNING'));
        return;
      }

      this.minStartDate = bounds.minStart;
      this.maxStartDate = bounds.maxEnd;
      this.minEndDate = bounds.minStart;
      this.maxEndDate = bounds.maxEnd;
      this.fillFirstDateBlockFromBounds(bounds);

      setTimeout(() => this.resources.controls.forEach((_, idx) => this.refreshAbsencePreviewForGroup(idx)));

    });




    this.orderSearchControl.valueChanges.subscribe(value => {
      this.filteredOrders = this.data.orders.filter(order =>
        !value || order.code.toLowerCase().includes(value.toLowerCase())
      );
    });

    this.form.get('resourceToAdd')?.valueChanges.subscribe((resourceToadd: any) => {
    })

    this.form.get('resources')?.valueChanges.subscribe(() => {
      this.checkAllRoleMismatches();
    });



    this.dates.valueChanges?.subscribe(() => {
      this.resources.controls.forEach((_, idx) => this.refreshAbsencePreviewForGroup(idx));
    });



    // quando cambia QUALSIASI valore nei gruppi risorse, aggiorna mismatch e anteprime
    this.form.get('resources')?.valueChanges.subscribe(() => {
      this.checkAllRoleMismatches();
      this.resources.controls.forEach((_, idx) => this.refreshAbsencePreviewForGroup(idx));
    });

    this.initResources();

    // ⬇️ AGGIUNGI QUESTO BLOCCO in EditOperatorsDialogComponent (NON nel plannerRiepilogo)
    const init = (this.data as any)?.initialFormValue;
    if (init) {
      // 1) orderId
      if (init.orderId != null) {
        this.form.get('orderId')?.setValue(init.orderId);
      }

      // 2) resources: ricrea le righe e patcha i valori
      const resArr = Array.isArray(init.resources) ? init.resources : [];
      this.resources.clear();
      if (resArr.length) {
        resArr.forEach((r: any) => {
          const g = this.createResourceGroup();
          g.patchValue({
            resourcesToReplace: r?.resourcesToReplace ?? null,
            resourcesToAdd: r?.resourcesToAdd ?? null
          }, { emitEvent: true });
          this.resources.push(g);
        });
      } else {
        this.initResources(); // fallback a una riga vuota
      }

      // 3) blocchi data (supporta sia init.date che init.dates)
      const rawBlocks = Array.isArray(init?.date) ? init.date
        : Array.isArray(init?.dates) ? init.dates
          : [];
      this.dates.clear();
      if (rawBlocks.length) {
        rawBlocks.forEach((b: any) => {
          const g = this.createDateBlockGroup();
          g.patchValue({
            startDate: b?.startDate ? new Date(b.startDate) : null,
            endDate: b?.endDate ? new Date(b.endDate) : null
          }, { emitEvent: true });
          this.dates.push(g);
        });
      } else {
        if (this.dates.length === 0) this.addDateBlock();
      }

      // forza ricalcolo validazioni/preview
      this.form.updateValueAndValidity();
      setTimeout(() => {
        this.checkAllRoleMismatches();
        this.resources.controls.forEach((_, idx) => this.refreshAbsencePreviewForGroup(idx));
      });
    }
  }
  private fillFirstDateBlockFromBounds(bounds: { minStart: Date; maxEnd: Date }) {
    if (this.dates.length === 0) this.addDateBlock();
    const first = this.dates.at(0) as FormGroup;
    first.patchValue({ startDate: bounds.minStart, endDate: bounds.maxEnd }, { emitEvent: true });
  }

  private computePreviewBounds(): { start: Date | null; end: Date | null } {
    const blocks = (this.dates.value || [])
      .filter((b: any) => b?.startDate && b?.endDate)
      .map((b: any) => ({ start: new Date(b.startDate), end: new Date(b.endDate) }));

    if (blocks.length) {
      const start = new Date(Math.min(...blocks.map((b: any) => b.start.getTime())));
      const end = new Date(Math.max(...blocks.map((b: any) => b.end.getTime())));
      return { start, end };
    }

    const selectedOrderIdsRaw = this.form.get('orderId')?.value;
    const ids: number[] = Array.isArray(selectedOrderIdsRaw)
      ? selectedOrderIdsRaw
      : (selectedOrderIdsRaw != null ? [selectedOrderIdsRaw] : []);
    if (!ids.length) return { start: null, end: null };

    const bounds = this.computeDateBoundsForOrders(ids);
    if (!bounds) return { start: null, end: null };
    return { start: bounds.minStart, end: bounds.maxEnd };
  }


  checkAllRoleMismatches() {
    this.showRoleMismatchWarning = this.resources.controls.some((group, index) => {
      const resourceToReplaceId = group.get('resourcesToReplace')?.value;
      const resourceToAddId = group.get('resourcesToAdd')?.value;

      const resourceToReplace = this.getResourceById(resourceToReplaceId);
      const resourceToAdd = this.getResourceById(resourceToAddId);

      return resourceToReplace && resourceToAdd && resourceToReplace.idRuolo === 36 && resourceToAdd.idRuolo === 35;
    });
  }


  filterResourcesByRole(roleId: number) {
    return this.data.resources.filter(resource => resource.idRuolo === roleId);
  }


  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    if (this.form.valid) {
      const fv = this.enrichPayloadWithRoleIds(this.form.value);
      const date = (this.dates.value || [])
        .filter((b: any) => b?.startDate && b?.endDate)
        .map((b: any) => ({
          startDate: b.startDate,
          endDate: b.endDate,
        }));
      this.dialogRef.close({ ...fv, date });
    }
  }



  private getOrderIdFromTask(t: any): number | null {
    return Number(t?.orderIdId ?? t?.orderId ?? t?.Order?.id ?? null) || null;
  }




  checkRoleMismatch(groupIndex: number) {
    const resourceGroup = this.resources.at(groupIndex) as FormGroup;
    const resourceToReplaceId = resourceGroup.get('resourcesToReplace')?.value;
    const resourceToAddId = resourceGroup.get('resourcesToAdd')?.value;

    const resourceToReplace = this.getResourceById(resourceToReplaceId);
    const resourceToAdd = this.getResourceById(resourceToAddId);

    if (resourceToReplace && resourceToAdd && resourceToReplace.idRuolo !== resourceToAdd.idRuolo) {
      this.showRoleMismatchWarning = true;
    } else {
      this.showRoleMismatchWarning = false;
    }
  }

  private enrichPayloadWithRoleIds(formValue: any): any {
    return {
      ...formValue,
      resources: formValue.resources.map((resource: any) => {
        const resourceToReplace = this.getResourceById(resource.resourcesToReplace);
        const resourceToAdd = this.getResourceById(resource.resourcesToAdd);

        return {
          ...resource,
          resourceToReplaceRuoloId: resourceToReplace ? resourceToReplace.idRuolo : null,
          resourceToAddRuoloId: resourceToAdd ? resourceToAdd.idRuolo : null
        };
      })
    };
  }

  private getResourceById(id: number): any {
    return this.data.resources.find((res: any) => res.id === id);
  }
  get resources(): FormArray {
    return <FormArray>this.form.get('resources');
  }


  initResources() {
    this.resources.push(this.createResourceGroup());
  }

  createResourceGroup(): FormGroup {
    const groupIndex = this.resources.length;
    const group = this.fb.group({
      resourcesToReplace: [null, [Validators.required]],
      resourcesToAdd: [null, [Validators.required]],
    }, { validators: this.differentOperatorsValidator.bind(this) });

    this.availableResources[groupIndex] = this.filterResourcesToReplaceByOrderIds(this.form.get('orderId')?.value || []);
    this.filteredResourcesToAdd[groupIndex] = this.data.resources;
    this.availableResourcesFiltered[groupIndex] = this.availableResources[groupIndex]; // Aggiungi questa riga

    const resourceToReplaceSearchControl = new FormControl();
    const filteredResourcesToAdd = new FormControl();

    this.resourcesToReplaceSearchControls.push(resourceToReplaceSearchControl);
    this.resourcesToAddSearchControls.push(filteredResourcesToAdd);

    resourceToReplaceSearchControl.valueChanges.subscribe(value => {
      this.availableResourcesFiltered[groupIndex] = this.availableResources[groupIndex].filter(res =>
        !value || res.name.toLowerCase().includes(value.toLowerCase())
      );
    });

    filteredResourcesToAdd.valueChanges.subscribe(value => {
      this.filteredResourcesToAdd[groupIndex] = this.data.resources.filter(res =>
        !value || res.name.toLowerCase().includes(value.toLowerCase())
      );
    });
    this.absencePreview[groupIndex] = { checked: false, items: [] };

    // aggiorna anteprima quando cambia la risorsa da aggiungere
    group.get('resourcesToAdd')?.valueChanges.subscribe(val => {
      this.L(`resourcesToAdd[group ${groupIndex}]→`, val);
      this.refreshAbsencePreviewForGroup(groupIndex);
    });


    return group;
  }

  filterResourcesToReplaceByOrderIds(orderIds: number[]): any[] {
    if (!orderIds || orderIds.length === 0) return [];

    // Mappa: userId -> Set(orderId in cui compare)
    const presence = new Map<number, Set<number>>();

    for (const task of (this.data.tasks || [])) {
      const oid = this.getOrderIdFromTask(task);
      if (!oid || !orderIds.includes(oid)) continue;

      const uid = Number(task.userId);
      if (!uid) continue;

      if (!presence.has(uid)) presence.set(uid, new Set<number>());
      presence.get(uid)!.add(oid);
    }

    // Prendi gli userId presenti in TUTTE le commesse selezionate
    const commonUserIds = Array.from(presence.entries())
      .filter(([_, set]) => set.size === orderIds.length)
      .map(([uid]) => uid);

    const resources = (this.data.resources || []).filter((r: any) => commonUserIds.includes(r.id));

    // 👇 se vuoto → toast
    if (orderIds.length > 1 && resources.length === 0) {
      this.toastr.error(
        this.translate.instant('PLANNER.NoCommonResources'),
        this.translate.instant('TOASTR.WARNING')
      );
    }

    return resources;
  }



  filterUniqueResources(resources: any[], selectedOrderIds: number[]): any[] {
    // Crea un oggetto per tracciare quante volte ogni risorsa appare per i codici commessa selezionati
    const resourceCount = resources.reduce((acc, resource) => {
      if (!acc[resource.id]) {
        acc[resource.id] = new Set();
      }
      acc[resource.id].add(resource.orderId);
      return acc;
    }, {});

    // Filtra le risorse per includere solo quelle che appaiono in tutti i codici commessa selezionati
    const filteredResources = resources.filter(resource => {
      return resourceCount[resource.id].size === selectedOrderIds.length;
    });

    // Rimuove i duplicati
    const uniqueResources = [];
    const seenIds = new Set();
    for (const resource of filteredResources) {
      if (!seenIds.has(resource.id)) {
        uniqueResources.push(resource);
        seenIds.add(resource.id);
      }
    }

    return uniqueResources;
  }



  addResources(values: any): FormGroup {
    let resources: FormGroup = this.fb.group(values);
    return resources
  }

  removeResourceGroup(index: number): void {
    this.resources.removeAt(index);
    this.availableResources.splice(index, 1);  // Rimuovi le risorse disponibili corrispondenti
    this.filteredResourcesToAdd.splice(index, 1); // Rimuovi le risorse filtrate corrispondenti

  }


  addAnotherResourceAfter(i: number): void {
    const grp = this.createResourceGroup();
    this.resources.insert(i + 1, grp);

    // dupllica i filtri per mantenere UX consistente
    this.availableResources.splice(i + 1, 0, this.availableResources[i] || []);
    this.availableResourcesFiltered.splice(i + 1, 0, this.availableResourcesFiltered[i] || []);
    this.filteredResourcesToAdd.splice(i + 1, 0, this.filteredResourcesToAdd[i] || []);

    // init anteprima
    this.absencePreview.splice(i + 1, 0, { checked: false, items: [] });
  }





  private refreshAbsencePreviewForGroup(groupIndex: number): void {
    const group = this.resources.at(groupIndex) as FormGroup;
    const resToAddId = Number(group.get('resourcesToAdd')?.value);
    const { start, end } = this.computePreviewBounds();

    this.L(`refreshPreview[g${groupIndex}] resToAddId=`, resToAddId,
      'range=', start && moment(start).format('YYYY-MM-DD'), '→', end && moment(end).format('YYYY-MM-DD'));

    if (!resToAddId || !start || !end) {
      this.absencePreview[groupIndex] = { checked: false, items: [] };
      return;
    }

    const items = this.getAbsencePreviewFromMaps(Number(resToAddId), start, end);
    this.absencePreview[groupIndex] = { checked: true, items };

  }






  /** Estrae in modo sicuro l'id risorsa da un oggetto assenza con campi variabili */
  private getAbsenceResourceIdSafe(a: Absence | any): number | null {
    const raw = (a as any)?.resourceId ?? (a as any)?.userId ?? (a as any)?.id;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }

  /** yyyy-mm-dd locale */
  private ymdLocal(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  /** yyyy-mm-dd UTC (in caso le chiavi del Set siano in UTC) */
  private ymdUTC(d: Date): string {
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  /** Lista inclusiva di giorni (locale) in YYYY-MM-DD */
  private listDaysYMD(start: Date, end: Date): string[] {
    const out: string[] = [];
    const d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const last = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    for (; d <= last; d.setDate(d.getDate() + 1)) {
      out.push(this.ymdLocal(d));
    }
    return out;
  }

  /** Converte qualsiasi dettaglio in coppie start/end confrontabili */
  private normalizeDetails(list: any[] = []): Array<{ start: Date; end: Date; reason?: string }> {
    return list
      .map(d => {
        const s = d.start ?? d.from ?? d.dateFrom ?? d.ymd;
        const e = d.end ?? d.to ?? d.dateTo ?? d.ymd;
        if (!s || !e) return null;
        return {
          start: new Date(s),
          end: new Date(e),
          reason: d.reason ?? d.type ?? d.causalCode
        };
      })
      .filter(Boolean) as Array<{ start: Date; end: Date; reason?: string }>;
  }

  /**
   * Ritorna anteprima assenze per una risorsa nel range [start, end]
   * usando PRIMA absencesDetailsByUser, altrimenti absencesByUser.
   */
  private sameDay(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  private mergeConsecutiveByReason(items: Array<{ start: Date; end: Date; reason?: string }>) {
    if (!items.length) return [];
    // ordina per start
    items.sort((a, b) => a.start.getTime() - b.start.getTime());

    const oneDayMs = 24 * 60 * 60 * 1000;
    const out: Array<{ start: Date; end: Date; reason?: string }> = [];
    let cur = { ...items[0] };

    const isConsecutive = (aEnd: Date, bStart: Date) =>
      (new Date(aEnd.getFullYear(), aEnd.getMonth(), aEnd.getDate() + 1)).getTime() ===
      (new Date(bStart.getFullYear(), bStart.getMonth(), bStart.getDate())).getTime();

    for (let i = 1; i < items.length; i++) {
      const nxt = items[i];
      if (cur.reason === nxt.reason && (isConsecutive(cur.end, nxt.start) || nxt.start.getTime() <= cur.end.getTime() + oneDayMs)) {
        // estendi
        if (nxt.end.getTime() > cur.end.getTime()) cur.end = nxt.end;
      } else {
        out.push(cur);
        cur = { ...nxt };
      }
    }
    out.push(cur);
    return out;
  }

  /**
   * Ritorna anteprima assenze per una risorsa nel range [start, end]
   * usando PRIMA absencesDetailsByUser (range veri), altrimenti absencesByUser (singoli giorni).
   * Formatta: se start==end → "DD/MM/YYYY", altrimenti "DD/MM/YYYY → DD/MM/YYYY".
   */
  private getAbsencePreviewFromMaps(resourceId: number, start: Date, end: Date)
    : Array<{ display: string; reason?: string }> {
    const ridKey = String(resourceId);

    // 1) Dettagli con range
    const details = this.data.absencesDetailsByUser?.[ridKey] || [];
    if (details.length) {
      const norm = details
        .map(d => {
          const s = d.start ?? d.from ?? d.dateFrom ?? d.ymd;
          const e = d.end ?? d.to ?? d.dateTo ?? d.ymd;
          if (!s || !e) return null;
          return {
            start: this.parseMaybeYMD(s),
            end: this.parseMaybeYMD(e),
            reason: d.reason ?? d.type ?? d.causalCode
          };
        })
        .filter(Boolean) as Array<{ start: Date; end: Date; reason?: string }>;

      const s = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0);
      const e = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999);

      // filtra per overlap e poi compatta in range consecutivi con stessa causale
      const overlapped = norm.filter(a => a.start <= e && a.end >= s);
      const merged = this.mergeConsecutiveByReason(overlapped);

      return merged.map(a => ({
        display: this.sameDay(a.start, a.end)
          ? moment(a.start).format('DD/MM/YYYY')
          : `${moment(a.start).format('DD/MM/YYYY')} → ${moment(a.end).format('DD/MM/YYYY')}`,
        reason: a.reason
      }));
    }

    // 2) Fallback: Set di giorni
    const setOrArr = this.data.absencesByUser?.[ridKey];
    if (!setOrArr) return [];

    const set = new Set<string>(Array.from(setOrArr as any));
    if (!set.size) return [];

    // genera i giorni del range (locali) e accetta key locali o UTC
    const daysLocal = this.listDaysYMD(start, end);
    const hits: string[] = [];
    for (const ymd of daysLocal) {
      const d = new Date(ymd);
      const keyLocal = this.ymdLocal(d);
      const keyUTC = this.ymdUTC(d);
      if (set.has(keyLocal) || set.has(keyUTC)) hits.push(ymd);
    }
    if (!hits.length) return [];

    // comprimi i giorni consecutivi in intervalli
    hits.sort();
    const toMs = (ymd: string) => {
      const [y, m, day] = ymd.split('-').map(Number);
      return new Date(y, m - 1, day).getTime();
    };
    const oneDay = 24 * 60 * 60 * 1000;
    let a = hits[0], b = hits[0];
    const out: Array<{ display: string; reason?: string }> = [];
    const flush = () => {
      const [ay, am, ad] = a.split('-').map(Number);
      const [by, bm, bd] = b.split('-').map(Number);
      const aDate = new Date(ay, am - 1, ad);
      const bDate = new Date(by, bm - 1, bd);

      out.push({
        display: this.sameDay(aDate, bDate)
          ? moment(aDate).format('DD/MM/YYYY')
          : `${moment(aDate).format('DD/MM/YYYY')} → ${moment(bDate).format('DD/MM/YYYY')}`,
        reason: 'Assenza'
      });
    };

    for (let i = 1; i < hits.length; i++) {
      const cur = hits[i];
      if (toMs(cur) - toMs(b) === oneDay) b = cur;
      else { flush(); a = b = cur; }
    }
    flush();

    return out;
  }

  getResourceName(id: any): string {
    const rid = Number(id);
    return this.data.resources.find((r: any) => Number(r.id) === rid)?.name || '';
  }
  /** Parse robusto: se stringa 'YYYY-MM-DD' crea Date locale (y, m-1, d), altrimenti new Date(input) */
  private parseMaybeYMD(input: any): Date {
    if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [y, m, d] = input.split('-').map(Number);
      return new Date(y, m - 1, d, 0, 0, 0, 0);
    }
    return new Date(input);
  }

}

interface DialogData {
  currentUserRole: any;
  orders: any[];
  resources: any[];
  tasks: any[];

  // 👇 aggiunte (opzionali)
  absencesByUser?: Record<string, Set<string> | string[]>;
  absencesDetailsByUser?: Record<string, any[]>;
}


export interface EditOperatorsFormValue {
  orderId: string | null;
  resources: [{
    resourcesToReplace: string | null,
    resourcesToAdd: string | null
  }] | null;
  startDate: Date;
  endDate: Date;

}
interface ResourcesFormGroup<T extends EditOperatorsFormValue> {
  resourcesToReplace: FormControl<['resourcesToReplace']>;
  resourcesToAdd: FormControl<['resourcesToAdd']>;
}

interface EditOperatorsForm<T extends EditOperatorsFormValue> {
  orderId: FormControl<T['orderId']>;
  resources: FormArray<FormGroup<ResourcesFormGroup<T>>>;
  startDate: FormControl<T['startDate']>;
  endDate: FormControl<T['endDate']>;
}
interface Absence {
  resourceId: number;
  start: Date | string; // ISO o Date
  end: Date | string;
  reason?: string;
}

type AbsencePreviewItem = { display: string; reason?: string };
